import { useMutation } from '@tanstack/react-query';

import { EmailTemplatePreviewRequest, postEmailTemplatePreview } from '../endpoints/emailTemplates';

export const usePreviewEmailTemplateMutation = () =>
    useMutation({
        mutationFn: (request: EmailTemplatePreviewRequest) => postEmailTemplatePreview(request),
    });
